import Icon from '../components/Icon.vue'

Icon.register({
  'comment-dollar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32c141.4 0 256 93.1 256 208s-114.6 208-256 208c-38.4 0-74.7-7.1-107.4-19.4-24.6 19.6-74.3 51.4-140.6 51.4h0c-4.4 0-8-3.6-8-8 0-1.8 1-4.2 2.2-5.5 0.5-0.5 42.3-45.5 54.8-95.8-35.6-35.7-57-81.2-57-130.7 0-114.9 114.6-208 256-208zM280 334.4c30.3-3.6 53.4-31 49.3-63-2.9-23-20.7-41.3-42.9-47.7l-50.1-14.3c-3.6-1-6.1-4.4-6.1-8.1 0-4.6 3.8-8.4 8.4-8.4h32.8 0.1c2.9 0 7.5 1 10.2 2.2 4.8 2.2 10.4 1.7 14.1-2l17.5-17.5c5.3-5.3 4.7-14.3-1.5-18.4-9.5-6.3-20.4-10.1-31.8-11.5v-17.7c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.5c-30.3 3.6-53.4 31-49.3 63 2.9 23 20.7 41.3 42.9 47.7l50.1 14.3c3.6 1 6.1 4.4 6.1 8.1 0 4.6-3.8 8.4-8.4 8.4h-32.8c-3.6 0-7.1-0.8-10.3-2.2-4.8-2.2-10.4-1.7-14.1 2l-17.5 17.5c-5.3 5.3-4.7 14.3 1.5 18.4 9.5 6.3 20.4 10.1 31.8 11.5v17.7c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-17.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-dollar.js
// module id = 1224
// module chunks = 0